export function isValidLat(value) {
  if ((typeof value === 'number' || (typeof value === 'string' && value.length && !isNaN(value.trim())))
    && value > -90 && value < 90) return true;
  return false;
}
export function isValidLng(value) {
  if ((typeof value === 'number' || (typeof value === 'string' && value.length && !isNaN(value.trim())))
    && value > -180 && value < 180) return true;
  return false;
}

export default function filterLatLng(list) {
  const badList = [];
  const goodList = [];
  if (Array.isArray(list)) {
    list.forEach((el) => {
      if (!el.latitude || el.latitude < -90 || el.latitude > 90 ||
          !el.longitude || el.longitude < -180 || el.longitude > 180) {
        badList.push(el);
      } else {
        goodList.push(el);
      }
    });
  }
  return { goodList, badList };
}



// WEBPACK FOOTER //
// ./src/services/general/gestionLatLng.js